import React from "react";
import { SectionCard } from "./common";
import { SchemaForm } from "./forms";
import { api } from "@/lib/api";

const SCHEMA = [
  { key: "agency", label: "Agency" },
  { key: "manager_name", label: "Manager Name" },
  { key: "email", label: "Email", type: "email" },
  { key: "phone", label: "Phone" },
  { key: "mobile", label: "Mobile" },
  { key: "office_address", label: "Office Address" },
  { key: "emergency_contact", label: "Emergency Contact" },
  { key: "notes", label: "Notes" },
];

export function ManagerTab({ property, reload }) {
  const save = async (payload) => {
    await api.put(`/properties/${property.id}/manager`, { ...payload, communication_history: property.manager?.communication_history || [] });
    reload();
  };
  return (
    <SectionCard title="Property Manager">
      <SchemaForm schema={SCHEMA} initial={property.manager || {}} onSave={save} testidPrefix="manager" />
      <div className="mt-6">
        <div className="text-[10px] uppercase tracking-[0.12em] text-[#8A7F70] mb-2">Communication History</div>
        <div data-testid="manager-comm-history" className="border-2 border-dashed border-[#E4DACB] rounded-xl py-6 text-center text-[#A99F90] text-sm">
          No logged communications yet. Email integration arrives in a later sprint.
        </div>
      </div>
    </SectionCard>
  );
}
